import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ComponentProps } from 'react'

type FontAwesomeIconProps = ComponentProps<typeof FontAwesomeIcon>

interface IconProps extends Omit<FontAwesomeIconProps, 'icon'> {
  icon: IconProp
}

export const Icon = ({ icon, ...rest }: IconProps) => {
  return <FontAwesomeIcon icon={icon} {...rest} />
}
